import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import skins from './skins'
import { skin } from 'Utils'
import { PageView, TrackLinkDecrease, StoreLocation } from 'Blocks'
import View from './component'

const ProductListPageContainer = props => {
  return (
    <Fragment>
      <PageView url={props.location.pathname} />
      <TrackLinkDecrease url={props.location.pathname} />
      <StoreLocation location={props.location} />
      <View className={props.className} {...props} />
    </Fragment>
  )
}

ProductListPageContainer.propTypes = {
  className: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
}

export default skin(ProductListPageContainer, skins)
